import { useEffect, useCallback } from 'react';
import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';
import {
  SecuritiesChannel,
  PayloadCase,
} from '../store/securities.store.types';
import { useSecuritiesContext } from '../SecuritiesContext';
import PayloadUtil from '../utils';

export default function usePortfolioSender(allowUnsubscribe: boolean) {
  const { setChannel, socket, token, isAuthorized } = useSecuritiesContext();
  const accountNumber = useSecuritiesCredentialStore((s) => s.accountNumber);

  const handleAction = useCallback((actionType: PayloadCase) => {
    const isSubscribe = actionType === PayloadCase.SUBSCRIBE;

    const channelPayload = isSubscribe
      ? PayloadUtil.createSubscribePayload(accountNumber)
      : PayloadUtil.createUnsubscribePayload(accountNumber);

    if (socket && accountNumber) {
      setChannel(SecuritiesChannel.SECURITIES, channelPayload);
    }
  }, [setChannel, socket, token, accountNumber]);

  useEffect(() => {
    if (isAuthorized) {
      handleAction(PayloadCase.SUBSCRIBE);
    }

    return () => {
      if (allowUnsubscribe) handleAction(PayloadCase.UNSUBSCRIBE);
    };
  }, [isAuthorized, handleAction]);
}
